import { Injectable, Injector } from '@angular/core';
import { HttpDataService } from './http-data.service';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, lastValueFrom, Observable } from 'rxjs';
import { NO_EDITOR_PLAN } from '../assets/constants';

@Injectable({
  providedIn: 'root'
})
export class PlansService extends HttpDataService {
  private basePlans: any;
  private cachedScope: string;
  private basePlanOptionsSubject = new BehaviorSubject({});

  constructor(protected injector: Injector, protected translate: TranslateService) {
    super(injector, '/plans');
  }

  loadBasePlansCache(scope) {
    if (this.basePlans && this.cachedScope === scope) {
      this.basePlanOptionsSubject.next({ options: this.getBasePlanOptions() });
      return Promise.resolve(this.basePlans);
    }
    this.cachedScope = scope;
    return this.getBasePlans(scope).then((basePlans) => {
      this.basePlans = basePlans;
      this.basePlanOptionsSubject.next({ options: this.getBasePlanOptions() });
    });
  }

  getBasePlanOptions() {
    const planOptions = this.basePlans
      ? this.basePlans.docs.map((plan) => ({
          key: plan.type,
          value: this.translate.instant(`nouns.plans.${plan.type}`)
        }))
      : [];
    planOptions.unshift({
      key: NO_EDITOR_PLAN,
      value: this.translate.instant('nouns.plans.none')
    });
    return planOptions;
  }

  getBasePlanOptionsObservable(): Observable<any> {
    return this.basePlanOptionsSubject.asObservable();
  }

  getBasePlans(scope) {
    return lastValueFrom(this.http.get(`${this.baseUrl}/base-plans?scope=${scope}`))
      .then((res) => res)
      .catch((error) => this.handlePromiseError(error));
  }

  getClientPlan(clientId) {
    return lastValueFrom(this.http.get(`${this.baseUrl}/client/${clientId}?expired=true`))
      .then((res) => res)
      .catch((error) => this.handlePromiseError(error));
  }

  updateClientPlan(clientId, data) {
    return lastValueFrom(this.http.put(`${this.baseUrl}/client/${clientId}`, data))
      .then((res) => res)
      .catch((error) => this.handlePromiseError(error));
  }
  createClientPlan(clientId, data) {
    return lastValueFrom(this.http.post(`${this.baseUrl}/${clientId}`, data))
      .then((res) => res)
      .catch((error) => this.handlePromiseError(error));
  }
  deleteClientPlan(clientId) {
    return lastValueFrom(this.http.delete(`${this.baseUrl}/client?clientId=${clientId}`))
      .then((res) => res)
      .catch((error) => this.handlePromiseError(error));
  }
  deletePartnerPlan(partnerId) {
    return lastValueFrom(this.http.delete(`${this.baseUrl}/client?partnerId=${partnerId}`))
      .then((res) => res)
      .catch((error) => this.handlePromiseError(error));
  }
}
